import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('MRPController?page=' + page, {params});
    }, 
    getByPlant(plant) {
        return Service().get('MRPController/get-by-plant/' + plant);
    }, 
    show(id) {
        return Service().get('MRPController/show/'+id);
    },    
    create(params) {
        return Service().post('MRPController/create', params);
    },
    update(id, params) {
        return Service().post('MRPController/update/'+id, params);
    },
    delete(id) {
        return Service().post('MRPController/delete/'+id);
    }
}